module.exports = __webpack_public_path__ + "static/img/logo.a324cf9.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/home/pc/index1/logo.png
// module id = eY9f
// module chunks = 7